import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../Layouts/Spinner";
import ReactSelect from "react-select";
import { Card, CardBody, Modal } from "reactstrap";
import * as yup from "yup";
import * as XLSX from "xlsx";
import { getUserList } from "../../../redux/invoice/action";
import { exportAllReports, getAllReports } from "../../../redux/service/action";
import FullScreenLoader from "../../Layouts/FullScreenLoader/FullScreenLoader";
import { getMembershipList } from "../../../redux/membership/action";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import Check from "../../assets/images/checkk.svg";
import Cross from "../../assets/images/cross.svg";
import ZatcaModal from "../Invoice/ZatcaModal";
import { formatDateInput } from "../../Common/Utils/dateUtils";
import TestingAccountFilter from "../../Common/TestingAccountFilter";

export const invoiceReportValidation = () =>
  yup.object({
    start_date: yup.date(),
    end_date: yup
      .date()
      .min(yup.ref("start_date"), "End date cannot be before start date"),
    user_id: yup.string(),
  });

const TopUpReport = () => {
  const dispatch = useDispatch();
  const [endDates, setEndDates] = useState("");
  const [loading, setLoading] = useState(false);
    const [zatDetails, setZatDetails] = useState(null);
    const [zatcaMod, setZatcaMod] = useState(false);
  const [startDates, setStartDates] = useState("");
  const [reportsData, setReportsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectStatus, setSlectStatus] = useState("");
  const [showFilter, setSHowFilter] = useState(false);
  const [exportLoader, setExportLoader] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedOptionsMember, setSelectedOptionsMember] = useState([]);
  const [theFilterInfo, setTheFilterInfo] = useState({
    user_id: "",
    start_date: "",
    end_date: "",
    membership_id: "",
    status: "",
    testing_account_filter: "hide",
    type: "addons_report",
  });

  const [params, setParams] = useState({
    type: "addons_report",
    search_key: "",
    status: "",
    page: 1,
    per_page: 10,
    testing_account_filter: "hide",
  });
  const [params1, setParams1] = useState({
    page: 1,
    search_key: "",
    parent_id: 1,
  });

  const userList = useSelector((state) => state?.reusableSlice?.userList);
  const membershipList = useSelector(
    (state) => state?.reusableSlice?.membershipList
  );

  const invoiceOptions = [
    {
      value: 1,
      label: "Active",
    },
    {
      value: 2,
      label: "Expired",
    },
  ];
  const proOptions = userList?.users?.map((item) => ({
    value: item?.id,
    label: item?.company_name,
  }));

  const proMembOptions = membershipList?.memberships?.map((item) => ({
    value: item?.id,
    label: item?.title,
  }));

  useEffect(() => {
    if (showFilter) {
      dispatch(getMembershipList(params1));
      dispatch(getUserList({ search_key: "" }));
    }
  }, [dispatch, params, params1, showFilter]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      user_id: "",
      start_date: "",
      end_date: "",
      membership_id: "",
      status: "",
      testing_account_filter: "hide",
      type: "addons_report",
    },
    validationSchema: invoiceReportValidation,
    onSubmit: (values) => {
      if (
        values.user_id ||
        values.membership_id ||
        values.status ||
        values.start_date ||
        values.end_date ||
        values.testing_account_filter !== "hide"
      ) {
        handleSubmit(values);
      }
      return;
    },
  });

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    formik.setFieldValue("user_id", selected?.value);
  };

  const handleChangeMember = (selected) => {
    setSelectedOptionsMember(selected);
    formik.setFieldValue("membership_id", selected?.value);
  };

  const handleStartDateChange = (event) => {
    setStartDates(event.target.value);
    formik.setFieldValue("start_date", event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDates(event.target.value);
    formik.setFieldValue("end_date", event.target.value);
  };

  const handleSelectStatus = (stat) => {
    setSlectStatus(stat.values);
    formik.setFieldValue("status", stat.value);
  };

  const handleGetReports = (data) => {
    getAllReports(data)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          if (res.data.response) {
            setReportsData(res.data.response);
          } else {
            setReportsData([]);
          }
        }
      })
      .catch((e) => {
        console.log(e, "error in get report");
        setIsLoading(false);
      });
  };

  function extractDate(dateString) {
    return formatDateInput(dateString);
  }
  const handleExportReport = () => {
    setExportLoader(true);
    exportAllReports(theFilterInfo)
      .then((response) => {
        if (response.data) {
          setExportLoader(false);
          const header = [
            [
            "Sl",
            "Company Name",
            "Membership Plan",
            "Price",
            // "Duration Type",
            "Simplified Total",
            "Simplified Left",
            "VAT Total",
            "VAT Left",
            "Purchase Total",
            "Purchase Left",
            "Start Date",
            "End Date",
            "Status",
            ],
          ];
          const data = response.data.addons_report.map((prop, index) => [
            index + 1,
            prop.company_name,
            prop.membership_title,
            prop.price,
            prop.max_invoices == "10000" ? "Unlimited" : prop?.max_invoices,
            prop.invoice_left == "10000" ? "Unlimited" : prop?.invoice_left,
            prop.max_invoices1 == "10000" ? "Unlimited" : prop?.max_invoices1,
            prop.invoice_left1 == "10000" ? "Unlimited" : prop?.invoice_left1,
            prop.max_invoices2 == "10000" ? "Unlimited" : prop?.max_invoices2,
            prop.invoice_left2 == "10000" ? "Unlimited" : prop?.invoice_left2,
            extractDate(prop.start_date),
            extractDate(prop.end_date),
            prop.status === 1 ? "Active" : "Expired",
          ]);

          const worksheet = XLSX.utils.aoa_to_sheet(header); // Add headers
          XLSX.utils.sheet_add_aoa(worksheet, data, { origin: "A2" }); // Add data starting from row 2

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "AddOnReports.xlsx");
        }
      })
      .catch((e) => {
        console.log(e, "while exporting reports");
        setExportLoader(false);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    handleGetReports(params);
  }, [params]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const data = {
      ...values,
      page: 1,
      per_page: 10,
    };
    setParams((preval) => ({
      ...preval,
      page: 1,
      ...values,
    }));
    setTheFilterInfo(values);
    handleGetReports(data);
  };

  const handleClearFilter = () => {
    if (
      formik.values.user_id ||
      formik.values.membership_id ||
      formik.values.status ||
      formik.values.start_date ||
      formik.values.end_date ||
      formik.values.testing_account_filter !== "hide"
    ) {
      setSelectedOptions("");
      setSlectStatus("");
      setStartDates("");
      setEndDates("");
      setSelectedOptionsMember("");
      formik.resetForm();
      setIsLoading(true);
      setTheFilterInfo({
        user_id: "",
        start_date: "",
        end_date: "",
        membership_id: "",
        status: "",
        testing_account_filter: "hide",
        type: "addons_report",
      });
      setParams(() => ({
        type: "addons_report",
        search_key: "",
        status: "",
        page: 1,
        per_page: 10,
        testing_account_filter: "hide",
      }));
      handleGetReports({
        user_id: "",
        start_date: "",
        end_date: "",
        membership_id: "",
        status: "",
        page: 1,
        per_page: 10,
        testing_account_filter: "hide",
        type: "addons_report",
      });
    }
    return;
  };

    const handleZatcaDetails = (zat) => {
    setZatDetails(zat);
    setZatcaMod(true);
  };

  return (
    <Card className="">
      <div className="p-3">
        <div className="category-wrapper">
          <div className=" d-flex justify-content-between align-items-center w-100 mb-3">
            <h4>Top-Up Invoices</h4>
            <div className="d-flex justify-content-between align-items-center ">
              <button
                type="button"
                className="submit-btn filter-btn mx-5"
                onClick={() => setSHowFilter(!showFilter)}
              >
                <span>
                  <i className="fa-solid fa-filter"></i>{" "}
                  {showFilter ? "Hide Filter" : "Filter"}
                </span>
              </button>
              <button
                disabled={exportLoader}
                type="button"
                className="submit-btn"
                onClick={() => handleExportReport()}
                style={{ width: "max-content" }}
              >
                {exportLoader ? <Spinner /> : "Export"}
              </button>
            </div>
          </div>
          {showFilter && (
            <form onSubmit={formik.handleSubmit}>
              <div className="row">
                <div className="col-md-3 form-group">
                  <label>Select Company</label>
                  <ReactSelect
                    isClearable
                    value={selectedOptions}
                    onChange={handleChange}
                    options={proOptions}
                    placeholder="select company"
                  />
                </div>
                <div className="col-md-3 form-group">
                  <label>Select Membership</label>
                  <ReactSelect
                    isClearable
                    value={selectedOptionsMember}
                    onChange={handleChangeMember}
                    options={proMembOptions}
                    placeholder="select membership"
                  />
                </div>

                <div className="col-md-3 form-group">
                  <label>Select Status</label>
                  <ReactSelect
                    name="status"
                    id="status"
                    value={selectStatus}
                    onChange={handleSelectStatus}
                    options={invoiceOptions}
                    placeholder="select status"
                  />
                </div>

                <div className="col-md-3 form-group">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control w-100"
                    placeholder="Enter start date"
                    value={startDates}
                    onChange={handleStartDateChange}
                    onBlur={formik.handleBlur}
                    name="start_date"
                  />
                  {formik.touched.start_date && formik.errors.start_date ? (
                    <div className="error">{formik.errors.start_date}</div>
                  ) : null}
                </div>

                <div className="col-md-3 form-group">
                  <label>End Date</label>
                  <input
                    type="date"
                    className="form-control w-100"
                    placeholder="Enter end date"
                    value={endDates}
                    onChange={handleEndDateChange}
                    onBlur={formik.handleBlur}
                    min={startDates || undefined}
                    name="end_date"
                  />
                  {formik.touched.end_date && formik.errors.end_date ? (
                    <div className="error">{formik.errors.end_date}</div>
                  ) : null}
                </div>
                <TestingAccountFilter
                  value={formik.values.testing_account_filter}
                  onChange={formik.handleChange}
                />
              </div>
              <div
                className="d-flex align-items-center justify-content-center mt-3  "
                style={{ columnGap: "20px" }}
              >
                <button
                  className="submit-btn   "
                  style={{ width: "max-content" }}
                  type="submit"
                >
                  {!loading ? "Submit" : <Spinner />}
                </button>
                <button
                  type="button"
                  className="submit-btn  "
                  onClick={() => handleClearFilter()}
                  style={{ width: "max-content" }}
                >
                  Clear
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
      {isLoading ? (
        <FullScreenLoader />
      ) : (
        <CardBody className="table-sec px-3">
          <table className="table border-table-sec">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Company Name</th>
                <th scope="col">Membership Plan</th>
                <th scope="col">Price</th>
                {/* <th>Duration Type</th> */}
                <th scope="col" colSpan="2" className="text-center">
                  Simplified
                </th>
                <th scope="col" colSpan="2" className="text-center">
                  VAT
                </th>
                <th scope="col" colSpan="2" className="text-center">
                  Purchase
                </th>
               <th scope="col">Reported</th>
                  <th scope="col">Signed</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
              </tr>
              <tr>
                <th colSpan="5"></th>
                <th>Total</th>
                <th>Left</th>
                <th>Total</th>
                <th>Left</th>
                <th>Total</th>
                <th colSpan="3"></th>
              </tr>
            </thead>
            <tbody>
              {reportsData &&
              Array.isArray(reportsData.addons_report) &&
              reportsData.addons_report.length > 0 ? (
                reportsData.addons_report.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (params?.page - 1) * 10}</td>
                    <td>{item.company_name}</td>
                    <td>{item?.membership_title}</td>
                    <td>{item.price}</td>
                    <td>
                      {item?.max_invoices == "10000"
                        ? "Unlimited"
                        : item?.max_invoices}
                    </td>
                    <td>
                      {item?.invoice_left == "10000"
                        ? "Unlimited"
                        : item?.invoice_left}
                    </td>
                    <td>
                      {item?.max_invoices1 == "10000"
                        ? "Unlimited"
                        : item?.max_invoices1}
                    </td>
                    <td>
                      {item?.invoice_left1 == "10000"
                        ? "Unlimited"
                        : item?.invoice_left1}
                    </td>
                    <td>
                      {item?.max_invoices2 == "10000"
                        ? "Unlimited"
                        : item?.max_invoices2}
                    </td>
                    <td>
                      {item?.invoice_left2 == "10000"
                        ? "Unlimited"
                        : item?.invoice_left2}
                    </td>

                  <td>
                        {" "}
                        {item?.onboarding === 0 ? (
                          <h5>--</h5>
                        ) : (
                          <img
                            src={
                              item?.zatca_status == "REPORTED" ? Check : Cross
                            }
                            alt=""
                          />
                        )}{" "}
                      </td>
                      <td>
                        {" "}
                        {item?.onboarding === 0 ? (
                          <h5>--</h5>
                        ) : (
                          <img
                            src={item?.signed_xml_url ? Check : Cross}
                            alt=""
                          />
                        )}{" "}
                      </td>
                        <td>
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ columnGap: "10px" }}
                        >
                          <button
                            className="border-button"
                            onClick={() => handleZatcaDetails(item)}
                          >
                            <span>View</span>
                          </button>
                        </div>
                      </td>
                    {/* <td style={{ color: item.status === 1 ? "green" : "red" }}>
                      {item.status === 1 ? "Active" : "Expired"}
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" className="text-center">
                    Top-Up Invoices Not Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </CardBody>
      )}
            <Modal
            size="lg"
            isOpen={zatcaMod}
            className="zatca-modal"
            toggle={() => setZatcaMod(true)}
          >
            <ZatcaModal
              zatcaMod={zatcaMod}
              setZatcaMod={setZatcaMod}
              data={zatDetails}
            />
          </Modal>
      <CommonPagination
        params={params}
        setParams={setParams}
        pagination_meta={reportsData && reportsData?.pagination_meta}
      />
    </Card>
  );
};

export default TopUpReport;
